import { render } from "./DepartmentList.vue?vue&type=template&id=4c730c01&scoped=true"
import script from "./DepartmentList.vue?vue&type=script&lang=js"
export * from "./DepartmentList.vue?vue&type=script&lang=js"

import "./DepartmentList.vue?vue&type=style&index=0&id=4c730c01&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c730c01"]])

export default __exports__